import script from "./ContactsContextBoxes.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsContextBoxes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__